<template>
  <BModal
    :id="id"
    hide-footer
    hide-header
    :centered="true"
    content-class="rounded-lg"
    size="lg"
    @hidden="onHidden"
  >
    <div class="text-center p-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Konfirmasi"
        class="mx-auto"
        width="80px"
      >
      <div class="font-semibold text-[18px] text-[#333333] my-2">
        Finalisasi Pengajuan
      </div>
      <div class="mb-2">
        <p>Pastikan partner sudah melakukan konfirmasi sebelum menyetujui</p>
      </div>

      <form @submit.prevent="confirmApproval">
        <UploadArea v-model="form.file" />
        <div class="flex flex-row gap-6">
          <BButton
            variant="outline-primary"
            class="rounded grow"
            type="button"
            @click="$bvModal.hide(id)"
          >
            Batal
          </BButton>

          <BButton
            variant="primary"
            class="rounded grow"
            :disabled="form.file.length < 1"
            type="submit"
          >
            Ya, Setujui
          </BButton>
        </div>
      </form>
    </div>
  </BModal>
</template>

<script>
import UploadArea from './UploadArea.vue'

export default {
  name: 'ModalFinalApproval',
  components: {
    UploadArea,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        status: 'accepted',
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
        file: [],
      },
    }
  },
  methods: {
    /**
     * Emits an event to the parent component to confirm the approval.
     */
    confirmApproval() {
      this.$emit('final-approve', this.form)
    },
    onHidden() {
      this.form.file = []
    },
  },
}
</script>
